import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import { groupBy } from 'lodash';

const { NEWTUBE_API_SERVER } = url;
const FETCH_PARAMS_REQUEST = 'foundation/hire/FETCH_PARAMS_REQUEST';
const FETCH_PARAMS_SUCCESS = 'foundation/hire/FETCH_PARAMS_SUCCESS';
const FETCH_PARAMS_FAIL = 'foundation/hire/FETCH_PARAMS_FAIL';

const FETCH_ALL_PARAMS_REQUEST = 'foundation/hire/FETCH_ALL_PARAMS_REQUEST';
const FETCH_ALL_PARAMS_SUCCESS = 'foundation/hire/FETCH_ALL_PARAMS_SUCCESS';
const FETCH_ALL_PARAMS_FAIL = 'foundation/hire/FETCH_ALL_PARAMS_FAIL';

const FETCH_POSITION_PARAMS_REQUEST = 'foundation/hire/FETCH_POSITION_PARAMS_REQUEST';
const FETCH_POSITION_PARAMS_SUCCESS = 'foundation/hire/FETCH_POSITION_PARAMS_SUCCESS';
const FETCH_POSITION_PARAMS_FAIL = 'foundation/hire/FETCH_POSITION_PARAMS_FAIL';

const FETCH_POSITION_DEPARTMENT_PARAMS_REQUEST = 'foundation/hire/FETCH_POSITION_DEPARTMENT_PARAMS_REQUEST';
const FETCH_POSITION_DEPARTMENT_PARAMS_SUCCESS = 'foundation/hire/FETCH_POSITION_DEPARTMENT_PARAMS_SUCCESS';
const FETCH_POSITION_DEPARTMENT_PARAMS_FAIL = 'foundation/hire/FETCH_POSITION_DEPARTMENT_PARAMS_FAIL';

export default function reducer(state = {
  isParamLoading: false,
  paramDatas: [],
  isAllParamLoading: false,
  paramAllDatas: {},
  isParamPositionDatasLoading: false,
  paramPositionDatas: {},
  isParamPositionDepartmentDatasLoading: false,
  paramPositionDepartmentDatas: [],
}, action) {
  switch (action.type) {
    case FETCH_PARAMS_REQUEST:
      return Object.assign({}, state, {
        isParamLoading: true,
      });
    case FETCH_PARAMS_SUCCESS:
      return Object.assign({}, state, {
        isParamLoading: false,
        paramDatas: action.response.data,
      });
    case FETCH_PARAMS_FAIL:
      return Object.assign({}, state, {
        isParamLoading: false,
      });
    case FETCH_ALL_PARAMS_REQUEST:
      return Object.assign({}, state, {
        isAllParamLoading: true,
      });
    case FETCH_ALL_PARAMS_SUCCESS:
      return Object.assign({}, state, {
        isAllParamLoading: false,
        paramAllDatas: groupBy(action.response.data, 'type'),
      });
    case FETCH_ALL_PARAMS_FAIL:
      return Object.assign({}, state, {
        isAllParamLoading: false,
      });
    case FETCH_POSITION_PARAMS_REQUEST:
      return Object.assign({}, state, {
        isParamPositionDatasLoading: true,
      });
    case FETCH_POSITION_PARAMS_SUCCESS:
      return Object.assign({}, state, {
        isParamPositionDatasLoading: false,
        paramPositionDatas: groupBy(action.response.data, 'fieldCode'),
      });
    case FETCH_POSITION_PARAMS_FAIL:
      return Object.assign({}, state, {
        isParamPositionDatasLoading: false,
      });
    case FETCH_POSITION_DEPARTMENT_PARAMS_REQUEST:
      return Object.assign({}, state, {
        isParamPositionDepartmentDatasLoading: true,
      });
    case FETCH_POSITION_DEPARTMENT_PARAMS_SUCCESS:
      return Object.assign({}, state, {
        isParamPositionDepartmentDatasLoading: false,
        paramPositionDepartmentDatas: action.response.data,
      });
    case FETCH_POSITION_DEPARTMENT_PARAMS_FAIL:
      return Object.assign({}, state, {
        isParamPositionDepartmentDatasLoading: false,
      });
    default:
      return state;
  }
}

export function fetchParams(type) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}params?type=${type}`,
      method: 'GET',
      types: [
        FETCH_PARAMS_REQUEST,
        FETCH_PARAMS_SUCCESS,
        FETCH_PARAMS_FAIL,
      ],
    },
  };
}

export function fetchAllParams() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}params`,
      method: 'GET',
      types: [
        FETCH_ALL_PARAMS_REQUEST,
        FETCH_ALL_PARAMS_SUCCESS,
        FETCH_ALL_PARAMS_FAIL,
      ],
    },
  };
}

export function fetchPositionParams() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}fieldsettings/hire/DetialList`,
      method: 'GET',
      types: [
        FETCH_POSITION_PARAMS_REQUEST,
        FETCH_POSITION_PARAMS_SUCCESS,
        FETCH_POSITION_PARAMS_FAIL,
      ],
    },
  };
}

export function fetchPositionDepartmentParams(onboardingDate) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}PA/HireSetting/EffectiveDept?EffectiveDate=${onboardingDate}`,
      method: 'GET',
      types: [
        FETCH_POSITION_DEPARTMENT_PARAMS_REQUEST,
        FETCH_POSITION_DEPARTMENT_PARAMS_SUCCESS,
        FETCH_POSITION_DEPARTMENT_PARAMS_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Hire/reducers/paramReducer.js
 **/